module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('h1', [_vm._v("Epigraph")]), _vm._v(" "), _c('p', [_vm._v("There are earthbound artists who walk down the streets with their heads up, looking straight ahead. They look and plan, and organize, and their work is smart and wise, and well developed, and sometimes great. This group is always admired. Then, there is the other type of artist. They walk down the street with their heads down, lost in thought or daydreams. Every so often, they are obliged to lift their heads, always suddenly, embracing their field of vision in a series of rapid, oblique glances. This group “sees”. However, confused or eccentric their style, they see with a wonderful clarity.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("by Russell Gersten")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0